import QueryString from 'qs'
import { useContext, useEffect, useState } from 'react'
import { NavigateFunction, useLocation, useNavigate } from 'react-router-dom'
import '../css/AppBar.css'
import { delPrevScroll } from '../js/script'
// import { handlePostMessage } from '../js/postMessage'
import { BtnHeaderIcon } from './Button'
import { useAppContext } from './provider/AppProvider'
import { useCartContext } from './provider/CartProvider'
import useScrollRestore from '../hooks/useScrollRestore'

import { PathContext } from '../App'
import { AFWebLinkType, RNPostMessage } from '../js/postMessage'
// import { handlePostMessage } from '../js/postMessage';

type AppBarProps = {
  setCloseCheck: React.Dispatch<React.SetStateAction<boolean>>
  closeCheck: boolean
}

export default function AppBar({ setCloseCheck, closeCheck }: AppBarProps) {
  const [direct, setDirect] = useState<boolean>(false)
  const { isAppView, setStorageAppValue } = useAppContext()
  const { cartCount } = useCartContext()
  const location = useLocation()
  // 이미지 경로
  const imgURL: string = '/images'
  const navigate: NavigateFunction = useNavigate()
  const { path } = useContext(PathContext)

  useScrollRestore()

  useEffect(() => {
    const query = QueryString.parse(location.search, {
      ignoreQueryPrefix: true,
    })
    if (query.app) setStorageAppValue(true)

    if (query.direct) {
      setDirect(true)
    } else {
      setDirect(false)
    }
  }, [location.search])

  const pathGoBack = () => {
    if (isAppView) {
      RNPostMessage(AFWebLinkType.goBack)
    } else {
      navigate(-1)
    }
  }
  return (
    <>
      <div className='appbar_wrap'>
        {!isAppView && !closeCheck && (
          <div className='applink_bar'>
            <a href='https://aboutfishing.onelink.me/oR5G/ggsxif1g'>
              <img src='/images/app_logo_icon.png' alt='' />
              <div>
                <p>적립금이 부족하다면? 앱에서 코인 받으세요!</p>
                <strong>어바웃피싱 앱으로 보기</strong>
              </div>
            </a>
            <button
              type='button'
              className='applink_close_btn'
              onClick={(): void => {
                setCloseCheck(true)
              }}
            >
              <img src='/images/icon_w_close.png' alt='' />
            </button>
          </div>
        )}
        <div className='appbar'>
          <div className='icons_left'>
            {/* 뒤로가기 */}
            {!direct && (
              <button
                onClick={() => {
                  pathGoBack()
                }}
              >
                <img src={`${imgURL}/icon_back.png`} alt='뒤로가기 아이콘' />
              </button>
            )}

            {/* 홈으로 가기 */}
            {/* <button
              onClick={(): void => {
                delPrevScroll()
                navigate('/')
              }}
            >
              <img src={`${imgURL}/icon_home.png`} alt='' />
            </button> */}
          </div>
          <div className='icons_right'>
            {/* 장바구니로 가기 */}
            <BtnHeaderIcon
              className='cart'
              onClick={(): void => {
                if (isAppView) {
                  RNPostMessage(AFWebLinkType.moveToLink, {
                    url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/cart`,
                  })
                } else {
                  navigate('/cart')
                }
              }}
            >
              <img src={`${imgURL}/icon_cart.png`} alt='' />
              {cartCount !== 0 && <span>{cartCount}</span>}
            </BtnHeaderIcon>
          </div>
        </div>
      </div>
    </>
  )
}
